import { useQuery, useMutation } from '@tanstack/react-query';
import { REACT_QUERY_GET_BRANDING_CONFIGS_QUERY_KEY } from '../constants';
import brandingUseCase from '../factories/branding';

export const useGetBrandingConfigs = (variables, options = {}) => {
  const query = useQuery({
    queryKey: [REACT_QUERY_GET_BRANDING_CONFIGS_QUERY_KEY, variables],
    queryFn: () => brandingUseCase.getBrandingConfigs(variables),
    ...options,
  });

  return query;
};

export const useUpdateBrandingConfigs = (options = {}) => {
  const mutation = useMutation({
    mutationFn: brandingUseCase.updateBrandingConfigs,
    ...options,
  });

  return mutation;
};
